import React from 'react';
import { useDebounce } from '@/hooks/useDebounce';
import { useTranslationWithLocale } from '@/hooks/useTranslationWithLocale';
import { cookiesData } from '../../../data';
import { CookiesItem } from '../CookiesItem';
import styles from './CookiesBody.module.scss';

export const CookiesBody: React.FC = () => {
	// States
	const [expanded, setExpanded] = React.useState<string | boolean>(false);

	// Helpers
	const setDefaultExpanded = useDebounce(() => setExpanded('essential'), 500);
	const { t } = useTranslationWithLocale('common');

	// Effects
	React.useEffect(() => {
		setDefaultExpanded();
	}, []);

	return (
		<div className={styles['body']}>
			<h3 className={styles['body__title']}>{t('cookies_popupTitle')}</h3>
			<div className={styles['body__list']}>
				{Object.keys(cookiesData).map((item: string) => (
					<CookiesItem
						key={item}
						name={item}
						item={cookiesData[item]}
						expanded={expanded}
						setExpanded={setExpanded}
					/>
				))}
			</div>
		</div>
	);
};
